import apiClient from './client';
import { API_ENDPOINTS } from './config';

// Request/Response types
export interface SignInRequest {
	userName: string;
	password: string;
}

export interface SignInResponse {
	token: string;
	name: string;
	image?: string;
	passwordChangeRequired?: boolean;
	phoneVerified?: boolean;
	role?: string; // Will be added later by API - hardcoded for now
}

export interface ChangePasswordRequest {
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
}

export interface ChangePasswordResponse {
	success: boolean;
	message: string;
	token: string;
	name: string;
	image?: string;
}

// Auth API functions
export const authApi = {
	/**
	 * Sign in with username/email and password
	 */
	signIn: async (credentials: SignInRequest): Promise<SignInResponse> => {
		return apiClient.post<SignInResponse>(API_ENDPOINTS.AUTH.SIGNIN, credentials);
	},

	/**
	 * Change password (used for first-time login password change)
	 */
	changePassword: async (data: ChangePasswordRequest): Promise<ChangePasswordResponse> => {
		return apiClient.post<ChangePasswordResponse>(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, data, {
			skipAuthRedirect: true,
		});
	},
};

export default authApi;
